module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountLicenses)
    }
  })])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.lowItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.number) + " ")])]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.issued.date, _vm.formats.formatDate)) + "\n            \n          ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v(_vm._s(item.activities.map(function (a) { return a.name; }).join(', ')))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.issued.org))])])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4352d089","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/LicensesPanel.vue
// module id = 1062
// module chunks = 1